import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'appUnitHourly',
})
export class UnitHourlyPipe implements PipeTransform {
  private readonly HOURLY_POSTFIX: string = ' h';

  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return '---';
    }

    return `${value}${this.HOURLY_POSTFIX}`;
  }
}
